import {
  Box,
  Container,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  return (
    <Box
      bg={useColorModeValue("gray.50", "gray.900")}
      color={useColorModeValue("gray.700", "gray.200")}
    >
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        align="center"
      >
        <Text fontSize={{ base: "xs", md: "md", lg: "lg" }}>© 2024 Implemented by Jingpeng Ruan. All rights reserved</Text>
        <Text fontSize={{ base: "xs", md: "md", lg: "lg" }}>Built on template shared by <u><a href="https://github.com/eldoraboo" target="_blank " rel="noreferrer">Eldora Boo</a></u></Text>
      </Container>
    </Box>
  );
}
